import React, { useEffect, useState } from 'react'
import { AiOutlinePlusCircle, AiOutlineDelete, AiOutlineEdit } from 'react-icons/ai';
import axios from 'axios';
import Select from 'react-select';
import ToastNotification from '../../../components/ToastNotification';
import { useLoading } from '../../../context/LoadingContext';
import { CiEdit } from "react-icons/ci";
import { FaTimes } from 'react-icons/fa';

function DebitNote({ adminData, companyID, branchID ,financialYear }) {
   const { setLoading } = useLoading();
      const [showForm, setShowForm] = useState(false);
      const [searchTerm, setSearchTerm] = useState('');
      const [editId, setEditId] = useState(null);
      const [isEditMode, setIsEditMode] = useState(false);
      const [account, setAccount] = useState([]);
      const [accountRow, setAccountRow] = useState([]);
      const [bankAccount, setBankAccount] = useState([]);
      const [branchDetail, setBranchDetail] = useState([])
      const [editingCompanyId, setEditingCompanyId] = useState(null);

         const [fromMonth, setFromMonth] = useState('');
      const [toMonth, setToMonth] = useState('');  

      
          const [offset, setOffset] = useState(0);
          const limit = 20;
          const [hasMore, setHasMore] = useState(true);
          const [fromDate, setFromDate] = useState();
          const [toDate, setToDate] = useState();
          const [isLocked, setIsLocked] = useState(false);
          const [fy, setFy] = useState([]);
            const [validUpto, setValidUpto] = useState(null);
      
          const [financialRange, setFinancialRange] = useState({
              from_date: '',
              to_date: ''
          });
  
      const getCurrentDateTime = () => {
          const now = new Date();
          const year = now.getFullYear();
          const month = String(now.getMonth() + 1).padStart(2, "0");
          const day = String(now.getDate()).padStart(2, "0");
          const hours = String(now.getHours()).padStart(2, "0");
          const minutes = String(now.getMinutes()).padStart(2, "0");
  
          return `${year}-${month}-${day}T${hours}:${minutes}`;
      };
  
  
      const [formData, setFormData] = useState({
          account: '',
          amount: '',
          payment_date: getCurrentDateTime(),
          cheque_no: '',
          cheque_date: '',
          remark: '',
          tableRow: [
              { account: '', amount: '', type: '', action: '' }
          ],
          payment_type:'',
      });
  
      const [files, setFiles] = useState({
          file: null,
  
      })
   
  
  
      const [toast, setToast] = useState({
          show: false,
          message: '',
          bg: 'success'
      });
  
         const showToast = (message, bg = 'success') => {
          setToast({ show: true, message, bg });
      };
  
      const addRow = () => {
          setFormData(prev => ({
              ...prev,
              tableRow: [
                  ...(prev.tableRow || []),
                  { account: '', amount: '', type: '', action: '' }
              ]
          }));
      };
  
  
      const accountOptions = account.map(acc => ({
          value: acc.id,
          label: acc.holder_name,
      }));
       const accountOptionsRow = accountRow.map(acc => ({
          value: acc.id,
          label: acc.holder_name,
      }));
  
      const handleRowChange = (e, index, field) => {
          const value = e.target.value;
          setFormData(prev => {
              const updatedRows = [...(prev.tableRow || [])];
              updatedRows[index][field] = value;
              return { ...prev, tableRow: updatedRows };
          });
      };
  
      const removeRow = (index) => {
          setFormData(prev => ({
              ...prev,
              tableRow: (prev.tableRow || []).filter((_, i) => i !== index)
          }));
      };
  
  
      const handleFileChange = async (e) => {
          const file = e.target.files[0];
  
          const fieldName = e.target.name;
          if (file) {
              const fileSizeInMB = file.size / (1024 * 1024);
              if (fileSizeInMB > 2) {
                  setToast("File size is too large! Please upload a file smaller than 2MB.", 'danger')
                  return;
              }
              setFiles(prevFiles => ({ ...prevFiles, [e.target.name]: file }));
          }
  
  
  
      };
  
      const handleFormOpen = () => {
          setShowForm(true);
          setEditId(null);
          setFormData({ status: "" });
      };
  
  
  
      const handleChange = (e) => {
          const name = e.target.name.trim();
          setFormData({
              ...formData,
              [name]: e.target.value
          });
      };
  
 
      const handleSubmit = async (e) => {
          e.preventDefault();
  
          if (!formData.account) {
              showToast("Please select an Account", "danger");
              return;
          }
          if (!formData.tableRow.length) {
              showToast("Please add at least one row", "danger");
              return;
          }
          try {
  
              const formPayload = new FormData();
  
              formPayload.append('account', formData.account);
              formPayload.append('payment_type', 'debit_note');
              formPayload.append('amount', formData.amount);
              formPayload.append('payment_date', formData.payment_date);
              formPayload.append('cheque_no', null);
              formPayload.append('cheque_date', null);
              formPayload.append('remark', formData.remark);
              formPayload.append('rows', JSON.stringify(formData.tableRow));
              formPayload.append("branchName", branchDetail.code);
  
  
              if (files.file) {
                  formPayload.append('file', files.file);
              }
  
  
              if (isEditMode && editingCompanyId) {
     
                  await axios.put(
                      `https://api.skyguard.group/api/update-debit-note/${editingCompanyId}`,
                      formPayload,
                      {
                          headers: { 'Content-Type': 'multipart/form-data' }
                      }
                  );
  
                  showToast("Debit note updated successfully!", "success");
              } else {
                  // ADD PAYMENT
                  await axios.post(
                      "https://api.skyguard.group/api/debit-note",
                      formPayload,
                      {
                          headers: { 'Content-Type': 'multipart/form-data' }
                      }
                  );
  
                  showToast("Debit note added successfully!", "success");
              }
              BankPaymentDetail(financialRange.from_date,
            financialRange.to_date,
            branchDetail.code,
            0);
              resetForm();
              setShowForm(false);
  
          } catch (error) {
              console.error("❌ Submit error:", error.response?.data || error.message);
              showToast("Failed to save debit note !", "danger");
          }
      };
  
  
  
      const fecthAccountDetail = async () => {
          setLoading(true)
          try {
              const resParty = await axios.get('https://api.skyguard.group/api/fetch-account');
              const result = resParty.data.result;


            const filteredAccounts = result.filter(acc => {
  const type = acc.type_account?.trim().toLowerCase();

  return (
    type === "sundry creditors" ||
    type === "sundry debtors"
  );
});

setAccount(filteredAccounts);

setAccountRow(result);

          } catch (error) {
              console.log(error)
          } finally {
              setLoading(false);
          }
      };
  
  
   

    const BankPaymentDetail = async (fromDate,
        toDate,
        branchCode,
        newOffset = 0) => {

    setLoading(true);

    if (!branchCode) {
            console.log("Branch code missing");
            return;
        }

    try {

     

        const res = await axios.get(
            'https://api.skyguard.group/api/fetch-debit-note',
            {
                    params: {
                        from_date: fromDate,
                        to_date: toDate,
                        branch_code: branchCode,
                        limit: limit,
                        offset: newOffset
                    }
                }
        );

        const result = res.data;

         console.log("Fetched:", result.length);

            // FIRST LOAD
            if (newOffset === 0) {
                setBankAccount(result);
                setHasMore(true);

            }
            // LOAD MORE
            else {

                setBankAccount(prev => {
                    const merged = [...prev, ...result];

                    // optional: remove duplicates (safety)
                    const unique = Array.from(
                        new Map(merged.map(item => [item.id, item])).values()
                    );

                    return unique;
                });
            }

            // check if more data exists
            if (result.length < limit) {
                setHasMore(false);
            }


        // const sortedData = result.sort((a, b) => b.id - a.id);
        // setBankAccount(sortedData);

    } catch (error) {

        console.log(error);

    } finally {

        setLoading(false);
    }
};
  
    const fetchBranchDetail = async () => {
        setLoading(true)
        try {
            const branchRes = await axios.get(`https://api.skyguard.group/api/fetch-branch-localData/${branchID}`);
            setBranchDetail(branchRes.data)
            return branchRes.data.code;
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false);
        }
    };

     const fetchYearDetail = async () => {
            setLoading(true);
            try {
                const branchCode = await fetchBranchDetail();
                const res = await axios.get(
                    `https://api.skyguard.group/api/fetch-financial-year-localData/${financialYear}`
                );
                const yearData = res.data;
                setFy(yearData);
                // setIsLocked(yearData.is_locked === 1);
                
                  setValidUpto(yearData.valid_up_to);
                let shouldLock = false;

        // First check is_locked
        if (Number(yearData.is_locked) === 1) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            const validUptoDate = new Date(yearData.valid_up_to);
            validUptoDate.setHours(0, 0, 0, 0);

            // Lock only if valid_up_to date has passed
            shouldLock = validUptoDate <= today;
        }

        setIsLocked(shouldLock);



                setFinancialRange({
                    from_date: yearData.from_date,
                    to_date: yearData.to_date
                });
    
                await BankPaymentDetail(
                    yearData.from_date,
                    yearData.to_date,
                    branchCode,
    
                );
            } catch (error) {
                console.log(error);
            } finally {
                setLoading(false);
            }
        };

           const isVoucherLocked = (paymentDate) => {
    if (!validUpto || !paymentDate) return false;

    const voucherDate = new Date(paymentDate);
    voucherDate.setHours(0, 0, 0, 0);

    const fyValidUpto = new Date(validUpto);
    fyValidUpto.setHours(0, 0, 0, 0);

    return voucherDate <= fyValidUpto;
};

      useEffect(() => {
          
          fecthAccountDetail();
             fetchBranchDetail();
        fetchYearDetail();
      }, []);
  
      const handleEdit = (form) => {
   const locked = isVoucherLocked(form.payment_date);
              setIsLocked(locked);

          let parsedItems = [];
          if (form.tableRow) {
              try {
                  let parsed = typeof form.tableRow === "string" ? JSON.parse(form.tableRow) : form.tableRow;
                  if (typeof parsed === "string") {
                      parsed = JSON.parse(parsed);
                  }
                  parsedItems = Array.isArray(parsed) ? parsed : [];
              } catch (err) {
                  console.log("Invalid tableRow:", err);
                  parsedItems = [];
              }
          }
  
  
          if (!Array.isArray(parsedItems) || parsedItems.length === 0) {
              parsedItems = [{ account: '', amount: '', type: '', action: '' }];
          }
  
          setFormData(prev => ({
              ...prev,
              id: form.id || '',
              account: form.account || '',
              amount: form.amount || '',
              payment_date: form.payment_date || "",
              cheque_no: form.cheque_no || '',
              cheque_date: form.cheque_date || '',
              remark: form.remark || '',
              tableRow: parsedItems,
                branchName:form.branchName  || "",
             inv_no:form.inv_no || ""
          }));
  
  
          setFiles({
              file: form.file || null,
          });
  
          setEditingCompanyId(form.id);
          setIsEditMode(true);
          setShowForm(true);
      };
  
  
  
      const resetForm = () => {
          setFormData({
              account: '',
              amount: '',
              payment_date: getCurrentDateTime(),
              cheque_no: '',
              cheque_date: '',
              remark: '',
              tableRow: [{ account: '', amount: '', type: '', action: '' }]
          });
  
      }
  
    const filteredData = bankAccount.filter(itm =>
      Object.values(itm).some(val =>
        String(val).toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  

  
    const totalRowAmount = (formData.tableRow || []).reduce(
        (sum, row) => {
            const amt = Number(row.amount || 0);
            return row.type === "Dr" ? sum - amt : sum + amt;
        },
        0
    );

        const handleLoadMore = () => {

        const nextOffset = offset + limit;
        setOffset(nextOffset);

        BankPaymentDetail(
            financialRange.from_date,
            financialRange.to_date,
            branchDetail.code,
            nextOffset
        );
    };
  return (
     <>
               <div className='main-section'>
                   <ToastNotification
                       show={toast.show}
                       message={toast.message}
                       bg={toast.bg}
                       onClose={() => setToast({ ...toast, show: false })}
                   />
                   <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
                       <h3 className='my-3 fw-bold fs-5 golos'>Debit  Note</h3>
                       <div className="mb-3 row gx-3 gy-2 align-items-center d-flex justify-content-between">
                           <div className="col-12 col-md-5">
                               <input
                                   type="text"
                                   className="form-control border-0 border-bottom border-dark"
                                   placeholder="Search..."
                                   value={searchTerm}
                                   onChange={(e) => setSearchTerm(e.target.value)}
                                   required
                               />
                           </div>
                            <div className="col-12 col-md-2 d-flex justify-content-end">
                                                     <button
                                                         className={`btn ${showForm ? 'btn-danger' : 'btn-success'}`}
                                                         onClick={() => {
                                                             setShowForm(prev => !prev);
                         
                                                             // when closing form → reset
                                                             if (showForm) {
                                                                 setIsEditMode(false);
                                                                 setEditingCompanyId(null);
                                                                 resetForm();
                                                             }
                                                         }}
                                                     >
                                                         {showForm ? (
                                                             <>
                                                                 Close <FaTimes size={18} />
                                                             </>
                                                         ) : (
                                                             <>
                                                                 Add <AiOutlinePlusCircle size={18} />
                                                             </>
                                                         )}
                                                     </button>
                                                 </div>
                       </div>
   
                       {showForm && (
                           <div className='card p-3 my-3 shadow-sm bg-white border'>
                             <fieldset >
                                    <form onSubmit={handleSubmit}>
                                   
                                                                     {isEditMode && (
  <div className="mb-3">
    <label>Document No:</label> <br />
    <span className="badge bg-primary px-3 py-2">

      {`DN/${formData.inv_no}/${formData.branchName || ""}`}
    </span>
  </div>
)}

                                   <div className='row g-3'>
   
                                       <div className="col-md-4">
                                           <label className="form-label fw-medium">Account</label>
                                           <div className="d-flex align-items-end mb-3">
                                               <div className="flex-grow-1 me-2">
                                                 
                                                   <Select
                                                       options={accountOptions}
                                                       value={accountOptions.find(opt => opt.value === Number(formData.account)) || null}
                                                       onChange={(selected) =>
                                                           setFormData(prev => ({
                                                               ...prev,
                                                               account: selected ? selected.value : ""
                                                           }))
                                                       }
                                                       placeholder="Select Account..."
                                                          isDisabled={isEditMode && isLocked}
                                                   />
                                               </div>
   
                                           </div>
                                       </div>
   
                                      <div className="col-md-4">
                                           <label className="form-label fw-medium">
                                               Amount
                                           </label>
                                           <input
                                               type="number"
                                               className="form-control"
                                               name="amount"
                                               placeholder="Enter here..."
                                               value={formData.amount}
                                               onChange={handleChange}
                                               required
                                                disabled={isEditMode && isLocked}
                                           />
                                       </div>
                                       <div className="col-md-4">
                                           <label className="form-label fw-medium">
                                               Date
                                           </label>
                                           <input
                                               type="datetime-local"
                                               className="form-control"
                                               name="payment_date"
                                               placeholder="Enter here..."
                                               value={formData.payment_date}
                                               onChange={handleChange}
                                               required
                                                disabled={isEditMode && isLocked}
                                           />
                                       </div>
                                     
                                     
   
                                       <div className="table-responsive my-4">
                                           <div className="d-flex justify-content-end mb-2">
                                               <button
                                                   type="button"
                                                   className="btn btn-primary btn-sm col-md-1"
                                                   onClick={addRow}
                                                    disabled={isEditMode && isLocked}
                                               >
                                                   + Add Item
                                               </button>
   
                                           </div>
                                           <table className="table table-bordered mx-auto text-center align-middle w-75">
                                               <thead className="table-primary">
                                                   <tr>
                                                       <th>Account</th>
                                                       <th>Amout</th>
                                                       <th>Type</th>
                                                       <th>Action</th>
                                                   </tr>
                                               </thead>
   
                                               <tbody>
                                                   {(formData.tableRow || []).map((row, index) => (
                                                       <tr key={index}>
                                                           <td className="d-flex align-items-center">
                                                               <div className="flex-grow-1">
                                                                   <Select
                                                                       options={accountOptionsRow}
                                                                       value={
                                                                           accountOptionsRow.find(
                                                                               opt => opt.value === row.account
                                                                           ) || null
                                                                       }
                                                                       onChange={(selected) =>
                                                                           handleRowChange(
                                                                               { target: { value: selected.value } },
                                                                               index,
                                                                               'account'
                                                                           )
                                                                       }
                                                                       menuPortalTarget={document.body}
                                                                       styles={{
                                                                           container: base => ({ ...base, width: "100%" }),
                                                                           menuPortal: base => ({ ...base, zIndex: 9999 })
                                                                       }}
                                                                       placeholder="Select account..."
                                                                          isDisabled={isEditMode && isLocked}
                                                                   />
                                                               </div>
                                                           </td>
   
   
                                                           <td className="text-center" >
                                                               <input type='number' className='form-control'
                                                                   value={row.amount || ''}  
                                                                   onChange={(e) => handleRowChange(e, index, 'amount')}
                                                                    disabled={isEditMode && isLocked}
                                                               />
                                                           </td>
   
                                                           <td style={{ minWidth: "100px" }}>
                                                               <Select
                                                                   options={[
                                                                       { value: "Dr", label: "Dr" },
                                                                       { value: "Cr", label: "Cr" }
                                                                   ]}
                                                                   value={[{ value: "Dr", label: "Dr" }, { value: "Cr", label: "Cr" }].find(
                                                                       opt => opt.value === row.type
                                                                   ) || null}
                                                                   onChange={(selected) => handleRowChange({ target: { value: selected.value } }, index, 'type')}
                                                                   menuPortalTarget={document.body}
                                                                   styles={{
                                                                       container: base => ({ ...base, width: "100%" }),
                                                                       menuPortal: base => ({ ...base, zIndex: 9999 })
                                                                   }}
                                                                      isDisabled={isEditMode && isLocked}
                                                               />
                                                           </td>
   
   
                                                          
   
   
                                                           <td>
                                                               <button
                                                                   type="button"
                                                                   className="btn btn-danger btn-sm"
                                                                   onClick={() => removeRow(index)}
                                                                    disabled={isEditMode && isLocked}
                                                               >
                                                                   Delete
                                                               </button>
                                                           </td>
                                                       </tr>
                                                   ))}
   
                                               </tbody>
   
                                             <tfoot>
                                                <tr className="fw-bold">
                                                    <td colSpan="1" className="text-end">
                                                        Total
                                                    </td>
                                                    <td className="text-center">
                                                        {totalRowAmount}
                                                    </td>
                                                    <td colSpan="4"></td>
                                                </tr>
                                            </tfoot>
   
   
                                           </table>
                                       </div>
   
   
   
                                       <div className='row g-2'>
   
                                           <div className="col-md-6">
                                               <label className="form-label fw-medium">Upload Attachments</label>
   
                                               <input type="file" className="form-control" name='file' accept="image/*,application/pdf" onChange={handleFileChange}  disabled={isEditMode && isLocked}/>
                                               {isEditMode && files.file && typeof files.file === "string" && (
                                                   <div className="mt-2">
                                                       <span>Previous file: </span>
                                                       <a href={`https://api.skyguard.group/uploads/${files.file}`} target="_blank" rel="noopener noreferrer">{files.file}</a>
                                                   </div>
                                               )}
                                           </div>
                                           <div className='col-md-6'>
                                               <label htmlFor='remark' className="form-label fw-medium">Remarks</label>
                                               <textarea
                                                   className="form-control"
                                                   name="remark"
                                                   id="remarks"
                                                   placeholder="Enter here..."
                                                   rows="6"
                                                   value={formData.remark}
                                                   onChange={handleChange}
                                                   required
                                                    disabled={isEditMode && isLocked}
                                               />
                                           </div>
                                       </div>
                                   </div>
   
   
                                   <div className='d-flex justify-content-end mt-4 gap-2'>
                                       <button type="submit" className='btn btn-success'  disabled={isEditMode && isLocked}>
                                           {isEditMode ? 'Update' : 'Save'}
                                       </button>
                                       <button
                                           type='button'
                                           className='btn btn-danger'
                                           onClick={() => {
                                               setShowForm(false); setIsEditMode(false); resetForm();
                                           }}
                                       >
                                           Cancel
                                       </button>
                                   </div>
                               </form>
                             </fieldset>
                          
                           </div>
                       )}

   
   
                
                       <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
                           <table className='table table-bordered table-striped table-hover text-center align-middle'>
   
                               <thead className='table-info'>
                                   <tr>
                                       <th scope='col'> SN</th>
                                      <th scope='col'>Action</th>
                                       <th scope='col'>Doc No</th>
                                       <th scope='col'>Account</th>
                                       <th scope='col'>Payment Date</th>
                                       <th scope='col'>Amount</th>
                                       <th scope='col'>Remark</th>
                                     
                                   </tr>
                               </thead>
                               <tbody>
   
   
                                   {filteredData.map((acc, idx) => (
                                       <tr key={idx}>
                                         <td>{filteredData.length - idx} </td>
                                                         <td>
                                               <button className="btn btn-success" onClick={() => handleEdit(acc)}>
                                                   <CiEdit size={20} />
                                               </button>
                                           </td>
                                           <td> {`DN/${acc.inv_no}/${acc.branchName}/${fy.financial_year.split('-')[0]}`}</td>
                                           <td>{acc.account_holder_name} </td>
                                           <td>{acc.payment_date}</td>
                                           <td>{acc.amount}</td>
                                           <td>{acc.remark} </td>
   
   
                                       
                                       </tr>
                                   ))}
   
                               </tbody>
                           </table>
                           {hasMore && (
                            <div className="text-center mt-3">
                                <button
                                    className="btn btn-primary"
                                    onClick={handleLoadMore}
                                >
                                    Load More
                                </button>
                            </div>
                        )}
                       </div>
                   </div>
               </div>
           </>
  )
}

export default DebitNote